import { jsx as _jsx } from "react/jsx-runtime";
import { ActivityIndicator } from 'react-native';
import { theme } from '@xbto/design-system';
export function LoadingIndicator({ color: colorName = 'primary', large = false, style, }) {
    return (_jsx(ActivityIndicator, { color: theme.color.text[colorName], size: large ? 'large' : 'small', style: style }));
}
